import { useCallback } from "react";
import type { MemorySliceDescriptor } from "../../shared";
import { ephemeralStore } from "../runtime/ephemeralStore";

/**
 * Returns a stable setter for an ephemeral slice without subscribing to value changes.
 *
 * @typeParam TValue Slice value type.
 * @param slice Slice descriptor.
 * @returns Updater compatible with `useState` setters.
 */
export const useEphemeralSliceSetter = <TValue>(
    slice: MemorySliceDescriptor<TValue>,
): ( next: TValue | ( ( previous: TValue ) => TValue ) ) => void => {
    return useCallback(
        ( next: TValue | ( ( previous: TValue ) => TValue ) ) => {
            ephemeralStore.setValue( slice, next );
        },
        [ slice ],
    );
};
